import * as Yup from "yup";

export const accountOptions = [
  { key: "free", text: "Free", value: "free" },
  { key: "premium", text: "Premium", value: "premium" },
  { key: "promo", text: "Promoción", value: "promocion" },
];

export function initialValues(plan) {
  return {
    title: plan?.title || "",
    miniature: plan?.miniature || "",
    file: null,
    description: plan?.description || "",
    account: plan?.account || "free",
    vrHeadsetNumber: plan?.vrHeadsetNumber || 0, // <-- En vez de undefined
    vrHeadsetModel: plan?.vrHeadsetModel || "",
    bagModel: plan?.bagModel || "",
    accessTime: plan?.accessTime || 0,
    curseBasic: plan?.curseBasic || false,
    curseCertification: plan?.curseCertification || false,
    publicity: plan?.publicity || false,
    teacherNumber: plan?.teacherNumber || 0,
    studentsNumber: plan?.studentsNumber || 0,
    support: plan?.support || false,
    educamaker: plan?.educamaker || false,
    price: plan?.price || 0,
  };
}

export function validationSchema() {
  return Yup.object({
    // Estos 5 campos son los únicos requeridos
    title: Yup.string().required("El título es obligatorio"),
    description: Yup.string().required("La descripción es obligatoria"),
    accessTime: Yup.number()
      .min(0, "El tiempo de acceso no puede ser negativo")
      .required("El tiempo de acceso es obligatorio"),
    teacherNumber: Yup.number()
      .min(0, "El número de profesores no puede ser negativo")
      .required("El número de profesores es obligatorio"),
    studentsNumber: Yup.number()
      .min(0, "El número de estudiantes no puede ser negativo")
      .required("El número de estudiantes es obligatorio"),
    price: Yup.number()
      .min(0, "El precio no puede ser negativo")
      .required("El precio es obligatorio"),

    // El resto de campos no son requeridos
    vrHeadsetNumber: Yup.number().nullable(),
    vrHeadsetModel: Yup.string().nullable(),
    bagModel: Yup.string().nullable(),
    curseBasic: Yup.boolean().notRequired(),
    curseCertification: Yup.boolean().notRequired(),
    publicity: Yup.boolean().notRequired(),
    support: Yup.boolean().notRequired(),
    educamaker: Yup.boolean().notRequired(),
  });
}
